import {all, fork, put, takeEvery,takeLatest, call, delay} from "redux-saga/effects"

import {
  MEDIA_PREVIEW,
  MEDIA_NEW,
  MEDIA_UPDATE,
  MEDIA_REMOVE,
  MEDIA_SEARCH
} from "constants/ActionTypes"

import {mediaDataSourceUpdate,mediaProcessSuccess,mediaProcessReset} from "appRedux/actions/setup/department/Media"
import {userSignOut} from "appRedux/actions/Auth"

import { APIGetRequest,APIPostRequest } from "util/connection"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import { isUndefined,filter,orderBy } from "lodash"
import { IndexedDBAdd, IndexDBGetDataAll } from "util/indexedDBLibrary"
import { getItems } from "util/localStorage"
import { ApiResponse } from "constants/ActionTypes"

function* mediaPreviewProcess(): Generator<any, void, any>{
    
    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/rpc/masterfile/media/list`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

    try {
      const response: ApiResponse = yield APIPostRequest(url, {}, API_PMS_HEADERS)

      if(response.status === 200)
      {
            const resultData = response.data?.result_data || response.data || []
            const mediaDataSource = resultData.map((obj: any, key: number) =>{
              const container = {} as any
                    container.key = key
                    container.media_id = obj.id
                    container.media_code = obj.code
                    container.media_name = obj.name
                    container.media_group_id = obj.group_id
                    container.media_group_name = obj.group
                    container.dept_type = obj.dept_type
                    container.require_info = obj.require_info
                    container.enabled = obj.enabled
                    container.vat_effect = obj.vat_effect

                return container
            })

            /* if no error put everything to reducer */
             yield put(mediaDataSourceUpdate(mediaDataSource))
             yield delay(100)
             yield IndexedDBAdd("ListBoxDB","objStoreMediaList",mediaDataSource)

      }else{
            /* Show error message and signout */
            const {message,data} = response.data || {}
            const processStatus = { status: false, action: "preview", message}
            yield put(mediaProcessSuccess(processStatus))
            yield delay(100)
            yield put(mediaProcessReset())
            yield delay(100)
            if(response.status === 403){
              /* if data is not null force signout */
              if(data)
                yield put(userSignOut())
            }
            
      }
      
    } catch (error) {
        const processStatus = { status: false, action: "preview", message:error}
        yield put(mediaProcessSuccess(processStatus))
        yield delay(100)
        yield put(mediaProcessReset())
        yield delay(100)
    }
    
}

function* mediaSearchProcess({payload}: any): Generator<any, void, any>{
  const storeValue = yield IndexDBGetDataAll('ListBoxDB', 'objStoreMediaList')
  const ReformalData = [...storeValue[0]] 
  const keyword = payload.toLowerCase()

  if(!isUndefined(keyword)){
      /* Search by name */
      const filtered_media_name = filter(ReformalData, function(o) {
        return o.media_name.toLowerCase().indexOf(keyword) > -1
      })

      const mergeData = [...new Set([...filtered_media_name])]

      yield put(mediaDataSourceUpdate(mergeData))
  }else 
      yield put(mediaDataSourceUpdate(ReformalData))
}

function* mediaCreateProcess({payload}: any): Generator<any, void, any>{
  const media_name = payload.media_name
  const media_code = payload.media_code
  const groupID = payload.media_group_id||null 
  const deptType = payload.dept_type
  const requireInfo = payload.require_info
  const active = payload.active
  const vatEffect = payload.vat_effect !== undefined ? payload.vat_effect : true

  let mediaInfo = {name:media_name,
                        code:media_code,
                        group_id:groupID,
                        dept_type:deptType,
                        require_info:requireInfo,
                        enabled:active,
                        vat_effect:vatEffect}

    
      
      try {

            const  { access_token }  = yield call(getItems, ['access_token'])
            const AccessToken = access_token
            const url = `${API_URL_V1}pms/rpc/masterfile/media/create`
            API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
            const API_DATABODY  = mediaInfo
            const response: ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

            if(response.status === 200){
                const resultCode = response.data?.result_code
                const resultMsg = response.data?.result_msg || response.data?.message
                
                if(resultCode === "0" || resultCode === 0){
                    const processStatus = { status: true, action: "create", message:"Create success."}
                    yield put(mediaProcessSuccess(processStatus))
                    yield delay(100)
                    yield put(mediaProcessReset())
                    yield delay(100)
                } else {
                    const processStatus = { status: false, action: "create", message: resultMsg || "Create failed."}
                    yield put(mediaProcessSuccess(processStatus))
                    yield delay(100)
                    yield put(mediaProcessReset())
                    yield delay(100)
                }
            }else{
              const {message,data} = response.data || {}
              const processStatus = { status: false, action: "create", message: message || "Create failed."}
              yield put(mediaProcessSuccess(processStatus))
              yield delay(100)
              yield put(mediaProcessReset())
              yield delay(100)
              if(response.status === 403){
                /* if data is not null force signout */
                if(data)
                  yield put(userSignOut())
              } 
            }  

      } catch (error) {
            const processStatus = { status: false, action: "create", message:error}
            yield put(mediaProcessSuccess(processStatus))
            yield delay(100)
            yield put(mediaProcessReset())
            yield delay(100)
      }
}

function* mediaUpdateProcess({payload}: any): Generator<any, void, any>{
  const media_name = payload.media_name
  const media_id = payload.media_id
  const media_code = payload.media_code
  const groupID = (!payload.media_group_id)?null:payload.media_group_id 
  const deptType = payload.dept_type
  const requireInfo = payload.require_info
  const active = payload.active
  const vatEffect = payload.vat_effect !== undefined ? payload.vat_effect : true

  let mediaInfo = {} as any
      mediaInfo.id = media_id
      mediaInfo.name = media_name
      mediaInfo.code = media_code
      mediaInfo.group_id = groupID
      mediaInfo.dept_type = deptType
      mediaInfo.require_info = requireInfo
      mediaInfo.enabled = active
      mediaInfo.vat_effect = vatEffect
  

  try {
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/rpc/masterfile/media/update`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY  = mediaInfo
        const response: ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

        if(response.status === 200){
            const resultCode = response.data?.result_code
            const resultMsg = response.data?.result_msg || response.data?.message
            
            if(resultCode === "0" || resultCode === 0){
                const processStatus = { status: true, action: "update", message:"Update success."}
                yield put(mediaProcessSuccess(processStatus))
                yield delay(100)
                yield put(mediaProcessReset())
                yield delay(100)
            } else {
                const processStatus = { status: false, action: "update", message: resultMsg || "Update failed."}
                yield put(mediaProcessSuccess(processStatus))
                yield delay(100)
                yield put(mediaProcessReset())
                yield delay(100)
            }
        }else {
          const {message,data} = response.data || {}
          const processStatus = { status: false, action: "update", message: message || "Update failed."}
          yield put(mediaProcessSuccess(processStatus))
          yield delay(100)
          yield put(mediaProcessReset())
          yield delay(100)
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        }

  } catch (error) {
        const processStatus = { status: false, action: "update", message:error}
        yield put(mediaProcessSuccess(processStatus))
        yield delay(100)
        yield put(mediaProcessReset())
        yield delay(100)
  }
}

function* mediaRemoveProcess({payload}: any): Generator<any, void, any>{
    const mediaRemove = payload
  

    try{
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/media/delete/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY = {id : mediaRemove}
        const response: ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)
        if(response.status === 200){
          const processStatus = { status: true, action: "delete", message:"Delete success."}
          yield put(mediaProcessSuccess(processStatus))
          yield delay(100)
          yield put(mediaProcessReset())
          yield delay(100)
        }else{
          const {message,data} = response.data || {}
          const processStatus = { status: false, action: "delete", message}
          yield put(mediaProcessSuccess(processStatus))
          yield delay(100)
          yield put(mediaProcessReset())
          yield delay(100)
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        }  
    }
    catch(error){
      const processStatus = { status: false, action: "delete", message:error}
      yield put(mediaProcessSuccess(processStatus))
      yield delay(100)
      yield put(mediaProcessReset())
      yield delay(100)
    }
}

/* Watcher Saga */
export function* mediaPreview() {
  yield takeLatest(MEDIA_PREVIEW, mediaPreviewProcess)
}
export function* mediaSearch(){
  yield takeLatest(MEDIA_SEARCH, mediaSearchProcess)
}
export function* mediaCreate(){
  yield takeEvery(MEDIA_NEW,mediaCreateProcess)
}
export function* mediaUpdate(){
  yield takeEvery(MEDIA_UPDATE, mediaUpdateProcess)
}
export function* mediaRemove(){
  yield takeEvery(MEDIA_REMOVE,mediaRemoveProcess)
}

export default function* rootSaga(): Generator<any, void, any> {
  yield all([fork(mediaPreview),
             fork(mediaSearch),
             fork(mediaCreate),
             fork(mediaUpdate),
             fork(mediaRemove)])
}